import React from "react";
import styles from "./Contact.module.css";
import ContactForm from "./sections/ContactForm";

function Contact() {
    return (
        <div className={styles.container}>
            <div className={styles.contactHero}>


                <div className={styles.leftContainer}>
                    <div className={styles.floatleft}>
                        <img src="/images/Left-ellipse.png" alt="concierge" />
                    </div>

                    <div className={styles.floatBottom}>
                        <img src="/images/contact.png" alt="concierge" />
                    </div>
                </div>

                <div className={styles.headlineText}>
                    <h1>Get in touch</h1>
                    <p>Have a question, partnership idea, or need support? We'd love to hear from you.</p>
                </div>

                <div className={styles.floatright}>
                    <img src="/images/Right-ellipse.png" alt="concierge" />
                </div>

            </div>

            <div className={styles.contactSection}>
                <div className={styles.contactInfo}>
                    <div className={styles.sectionHeader}>
                        <p className={styles.topheader}>Reach us directly</p>
                        <p className={styles.bottomheader}>Our team typically responds within a few hours during business days.</p>
                    </div>

                    <div className={styles.sectionInfo}>
                        <div className={styles.callUs}>
                            <div className={styles.imageContainer}><img src="./images/call.svg" alt="" /></div>

                            <div className={styles.cardInformation}>
                                <p className={styles.title}>Call Us</p>
                                <p className={styles.bottomText}>+234-708-688-678-8</p>
                            </div>
                        </div>

                        <div className={styles.email}>
                            <div className={styles.imageContainer}><img src="./images/mail.svg" alt="" /></div>

                            <div className={styles.cardInformation}>
                                <p className={styles.title}>Email</p>
                                <p className={styles.topText}>support@oyaconcierge.com</p>
                                <p className={styles.bottomText}>admin@oyaconcierge.com</p>
                            </div>
                        </div>
                    </div>
                </div>

                <ContactForm/>
            </div>
        </div>
    );
}

export default Contact